const currencyFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
});

const quantityFormatter = new Intl.NumberFormat('pt-BR', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 5,
});

const distanceFormatter = new Intl.NumberFormat('pt-BR', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const decimalFormatter = new Intl.NumberFormat('pt-BR', {
  minimumFractionDigits: 4,
  maximumFractionDigits: 4,
});

const isValidNumber = (value?: number | null): value is number =>
  typeof value === 'number' && Number.isFinite(value);

export const formatCurrency = (value?: number | null): string => {
  if (!isValidNumber(value)) {
    return '-';
  }

  return currencyFormatter.format(value);
};

export const formatQuantity = (value?: number | null): string => {
  if (!isValidNumber(value)) {
    return '-';
  }

  return quantityFormatter.format(value);
};

export const formatDistance = (value?: number | null): string => {
  if (!isValidNumber(value)) {
    return '-';
  }

  return distanceFormatter.format(value);
};

export const formatDecimal = (value?: number | null): string => {
  if (!isValidNumber(value)) {
    return '-';
  }

  return decimalFormatter.format(value);
};
